import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ThemeService {
    private darkModeKey = 'boostTaxiDarkMode';
    private darkModeSubject = new BehaviorSubject<boolean>(this.getInitialTheme());
    
    public darkMode$ = this.darkModeSubject.asObservable();

    constructor() {
        this.applyTheme(this.darkModeSubject.value);
    }

    private getInitialTheme(): boolean {
        const savedTheme = localStorage.getItem(this.darkModeKey);
        if (savedTheme !== null) {
            return savedTheme === 'true';
        }
        // Check system preference
        return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
    }

    public toggleDarkMode(): void {
        const newValue = !this.darkModeSubject.value;
        this.darkModeSubject.next(newValue);
        this.applyTheme(newValue);
        localStorage.setItem(this.darkModeKey, String(newValue));
    }

    public setDarkMode(isDark: boolean): void {
        this.darkModeSubject.next(isDark);
        this.applyTheme(isDark);
        localStorage.setItem(this.darkModeKey, String(isDark));
    }

    public isDarkMode(): boolean {
        return this.darkModeSubject.value;
    }

    private applyTheme(isDark: boolean): void {
        if (isDark) {
            document.body.classList.add('dark-mode');
        } else {
            document.body.classList.remove('dark-mode');
        }
    }
}

